export default "__VITE_ASSET__GRQl807i__"